import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Button } from '../../../components/button'
import { AssignmentButtonWrapper, TableWrapper } from '../../../styles/assignment/assignment';
import { Table } from '../../../components/table/table';
import { AdminSystemSettingsData } from '../../../services/tableData';
import { DeleteInstructorContainer } from '../../../styles/instructors/instructors';
import { CustomModal } from '../../../components/modal'
import { useState } from 'react';
// import { RowDots } from "../../../components/table/row-menu";


const AdminSystemSettings = ({ history }) => {
    const [showModal, setShowModal] = useState(false);

    const columns = [
        {
            name: "Session",
            selector: (row) => row.session,
        },
        {
            name: "Term",
            selector: (row) => row.term,
        },
        {
            name: "School Name",
            selector: (row) => row.schoolName,
        },
        {
            name: "Start Date",
            selector: (row) => row.startDate,
        },
        {
            name: "End Date",
            selector: (row) => row.endDate,
        },
        {
            name: "",
            selector: (row) => row.schoolCode,
            // width: "50px",
            cell: () => {
                return (
                    <Button style={{ backgroundColor: '#FF348E' }} size='small'>
                        ROLLBACK
                    </Button>
                );
            },
        },
    ];


    return (
        <>
            <CustomModal onClose={() => setShowModal(false)} showModal={showModal}>
                <DeleteInstructorContainer>
                    <p className='title'>Level Elevation</p>
                    <p className='sub-title'>Please confirm that you will like to close this Term and move to the next Term</p>

                    <div className="button-container">
                        <Button size='small'>CONFIRM</Button>
                        <Button onClick={() => setShowModal(false)} size='small' variant="secondary">CANCEL</Button>
                    </div>

                </DeleteInstructorContainer>
            </CustomModal>
            <DashboardWrapper>
                <MainContentWrapper fullHeight>
                    <Container>
                        <MainContent>
                            <Heading>
                                System Settings
                            </Heading>
                            <Breadcrumb
                                crumbs={['System Settings']}
                            />
                            <div style={{ marginTop: '2.9rem' }}>
                                <AssignmentButtonWrapper>
                                    <Button size="small" onClick={() => history.push('/admin/settings/school-settings')}>School Settings</Button>
                                </AssignmentButtonWrapper>
                                <TableWrapper>
                                    <Table
                                        columns={columns}
                                        data={AdminSystemSettingsData || []}
                                    />
                                </TableWrapper>
                            </div>
                            <div style={{
                                marginTop: '3.8rem'
                            }}>
                                <Button style={{
                                    marginLeft: 'auto'
                                }}
                                    variant="secondary"
                                    size="small"
                                    onClick={() => setShowModal(true)}
                                >CLOSE CURRENT TERM</Button>
                            </div>
                        </MainContent>
                    </Container>
                </MainContentWrapper>
            </DashboardWrapper >
        </>
    )
}

export default AdminSystemSettings
